(function () {
  var SECTION_SELECTOR = '.customer-reviews';
  var CAROUSEL_SELECTOR = '.kl_reviews__carousel, .klaviyo-swiper-wrapper';

  function getRealSlideCount(swiper) {
    return swiper.slides.filter(function (slide) {
      return !slide.classList.contains('swiper-slide-duplicate');
    }).length;
  }

  function getArrowUrls(section) {
    return {
      prev: section.getAttribute('data-arrow-prev') || '',
      next: section.getAttribute('data-arrow-next') || ''
    };
  }

  function replaceArrowIcon(button, src) {
    if (!button || !src) return;
    if (button.querySelector('.cr-carousel-arrow')) return;

    button.innerHTML =
      '<img src="' +
      src +
      '" width="20" height="10" alt="" aria-hidden="true" class="cr-carousel-arrow">';
  }

  function getSwiper(carousel) {
    var swiperEl = carousel.querySelector('.swiper.swiper-initialized');
    return swiperEl && swiperEl.swiper ? swiperEl.swiper : null;
  }

  function enableNavButtons(carousel) {
    carousel
      .querySelectorAll('.kl_reviews__carousel__prev_button, .kl_reviews__carousel__next_button')
      .forEach(function (btn) {
        btn.classList.remove('swiper-button-disabled');
        btn.disabled = false;
        btn.setAttribute('aria-disabled', 'false');
        btn.style.pointerEvents = 'auto';
      });
  }

  function navigatePrev(swiper) {
    var count = getRealSlideCount(swiper);

    if (swiper.params.loop) {
      swiper.slidePrev();
      return;
    }

    if (swiper.isBeginning) {
      swiper.slideTo(count - 1);
      return;
    }

    swiper.slidePrev();
  }

  function navigateNext(swiper) {
    var count = getRealSlideCount(swiper);

    if (swiper.params.loop) {
      swiper.slideNext();
      return;
    }

    if (swiper.isEnd) {
      swiper.slideTo(0);
      return;
    }

    swiper.slideNext();
  }

  function bindNavigation(section, carousel) {
    var prev = carousel.querySelector('.kl_reviews__carousel__prev_button');
    var next = carousel.querySelector('.kl_reviews__carousel__next_button');
    var arrows = getArrowUrls(section);

    if (prev && prev.dataset.crNavBound !== 'true') {
      prev.dataset.crNavBound = 'true';
      prev.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          var swiper = getSwiper(carousel);
          if (!swiper) return;

          replaceArrowIcon(prev, arrows.prev);
          navigatePrev(swiper);
          enableNavButtons(carousel);
        },
        true
      );
    }

    if (next && next.dataset.crNavBound !== 'true') {
      next.dataset.crNavBound = 'true';
      next.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();

          var swiper = getSwiper(carousel);
          if (!swiper) return;

          replaceArrowIcon(next, arrows.next);
          navigateNext(swiper);
          enableNavButtons(carousel);
        },
        true
      );
    }
  }

  function isMobileLayout() {
    return window.matchMedia('(max-width: 1023.98px)').matches;
  }

  function applyResponsiveSwiper(carousel, swiper) {
    if (!swiper) return;

    if (!swiper.__customerReviewsOriginalParams) {
      swiper.__customerReviewsOriginalParams = {
        slidesPerView: swiper.params.slidesPerView,
        centeredSlides: swiper.params.centeredSlides
      };
    }

    var mobileSpace = 16;
    var desktopSpace = 19;
    var slideGap = isMobileLayout() ? mobileSpace : desktopSpace;

    if (isMobileLayout()) {
      swiper.params.slidesPerView = 1;
      swiper.params.spaceBetween = 0;
      swiper.params.centeredSlides = false;
    } else {
      var original = swiper.__customerReviewsOriginalParams;
      swiper.params.slidesPerView = original.slidesPerView || 3;
      swiper.params.spaceBetween = 0;
      swiper.params.centeredSlides = original.centeredSlides;
    }

    carousel.style.setProperty('--cr-slide-gap', slideGap + 'px');

    swiper.update();
    enableNavButtons(carousel);
  }

  function keepNavEnabled(carousel, swiper) {
    enableNavButtons(carousel);

    if (swiper.__customerReviewsNavBound) return;
    swiper.__customerReviewsNavBound = true;

    ['slideChange', 'reachBeginning', 'reachEnd', 'resize', 'update'].forEach(function (eventName) {
      swiper.on(eventName, function () {
        enableNavButtons(carousel);
      });
    });
  }

  function initCarousel(section, carousel) {
    var swiper = getSwiper(carousel);
    if (!swiper || getRealSlideCount(swiper) < 2) return;

    var arrows = getArrowUrls(section);
    replaceArrowIcon(carousel.querySelector('.kl_reviews__carousel__prev_button'), arrows.prev);
    replaceArrowIcon(carousel.querySelector('.kl_reviews__carousel__next_button'), arrows.next);

    bindNavigation(section, carousel);
    keepNavEnabled(carousel, swiper);
    applyResponsiveSwiper(carousel, swiper);

    if (!section.__customerReviewsResizeBound) {
      section.__customerReviewsResizeBound = true;

      window.addEventListener('resize', function () {
        section.querySelectorAll(CAROUSEL_SELECTOR).forEach(function (item) {
          applyResponsiveSwiper(item, getSwiper(item));
        });
      });
    }
  }

  function scan(root) {
    var scope = root || document;

    scope.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      section.querySelectorAll(CAROUSEL_SELECTOR).forEach(function (carousel) {
        initCarousel(section, carousel);
      });
    });
  }

  function observeSection(section) {
    scan(section);

    if (section.__customerReviewsObserver) return;

    section.__customerReviewsObserver = new MutationObserver(function () {
      scan(section);
    });

    section.__customerReviewsObserver.observe(section, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    scan();
  });

  document.addEventListener('shopify:section:load', function () {
    scan();
  });
})();
